import React from "react";
import { Link } from "react-router-dom";
import config from "../../base/utils/config";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { BsCalendar2Week } from "react-icons/bs";
import { CgShoppingBag } from "react-icons/cg";
import set_day_name from "../../base/utils/set_day_name";
import moment from "jalali-moment";
import checkLength from "../../base/utils/check_length";
import Swal from "sweetalert2";

export default function ConcertBlock({ concert }) {
  function action() {
    if (concert?.status === "upcoming") {
      Swal.fire({
        text: "کنسرت مد نظر هوز فعال نشده",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
        timerProgressBar: true,
      });
    }
    if (concert?.status === "finished") {
      Swal.fire({
        text: "کنسرت مد نظر پایان یافته است",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
        timerProgressBar: true,
      });
    }
    if (concert?.status === "sold_out") {
      Swal.fire({
        text: "کنسرت مد نظر فروخته شده است",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
        timerProgressBar: true,
      });
    }
  }
  return (
    <Link
      onClick={() => action()}
      to={
        concert?.status === "sold_out" ||
        concert?.status === "upcoming" ||
        concert?.status === "finished"
          ? ""
          : `/concert/${concert.id}`
      }
    >
      <div
        className="position-relative rounded10 overflow-hidden h-100"
        style={{ minHeight: "250px" }}
      >
        {concert?.status === "sold_out" ? (
          <span
            className="position-absolute p-2 rounded10 bg-red fs-8 text-white fw-bolder"
            style={{ left: "0", top: "0", zIndex: 1 }}
          >
            تمام شد
          </span>
        ) : concert?.status === "upcoming" ? (
          <span
            className="position-absolute p-2 rounded10 bg-dark fs-8 text-white fw-bolder"
            style={{ left: "8px", top: "8px", zIndex: 1 }}
          >
            بزودی
          </span>
        ) : concert?.status === "finished" ? (
          <span
            className="position-absolute p-2 rounded10 bg-dark fs-8 text-white fw-bolder"
            style={{ left: "8px", top: "8px", zIndex: 1 }}
          >
            اتمام یافت
          </span>
        ) : concert?.status === "renewal" ? (
          <span
            className="position-absolute p-2 rounded10 bg-success fs-8 text-white fw-bolder"
            style={{ left: "8px", top: "8px", zIndex: 1 }}
          >
            تمدید شد
          </span>
        ) : (
          ""
        )}
        <img
          className="w-100 h-100 img-cover bg-gray"
          alt=""
          src={concert.image}
          style={{
            minHeight: "270px",
            filter:
              concert?.status === "sold_out"
                ? "grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg) saturate(600%) contrast(0.8)"
                : concert?.status === "upcoming" ||
                  concert?.status === "finished"
                ? "grayscale(100%)"
                : "",
          }}
        />
        <div
          className="position-absolute bottom-0 start-0 end-0 overflow-hidden"
          style={{
            margin: "0 -15px -15px",
            top: "52%",
            filter: concert?.status === "finished" ? "grayscale(100%)" : "",
          }}
        >
          <div
            className="w-100 h-100"
            style={{
              filter: "blur(15px)",
              backgroundColor: "gray",
              backgroundImage: `url(${concert.image})`,
              backgroundPosition: "bottom",
              backgroundSize: "cover",
            }}
          />
        </div>
        <div
          className="position-absolute bottom-0 start-0 end-0 p-2 text-white"
          style={{
            filter: concert?.status === "finished" ? "brightness(70%)" : "",
          }}
        >
          <p className="fs-7 mb-0 text-center mb-1 bg-black py-1 rounded-2">
            <span className="fs-8">شهر:</span> {concert.venue.city}
          </p>
          <p className="fs-7 mb-0 text-center mb-1">
            <span className="fs-8">کنسرت:</span> {concert.artist}
          </p>
          <p className="fs-8 mb-0 text-center mb-1">
            <HiOutlineLocationMarker className="ms-1" />
            {checkLength(concert.venue?.short_address, 26)}
          </p>
          <p className="fs-7 mb-0 text-center mb-1">
            <BsCalendar2Week className="ms-1" />
            <span className="mb-0 space-pre">
              {set_day_name(
                moment(
                  concert.dates[0]?.start_time,
                  "YYYY-MM-DD HH:mm:ss"
                ).day()
              )}
            </span>

            <span className="mb-0 space-pre me-1">
              {moment(
                concert.dates[0]?.start_time,
                "YYYY-MM-DD HH:mm:ss"
              ).format(`jMM/jDD`)}
            </span>
          </p>
          <button
            disabled={
              concert?.status === "sold_out" ||
              concert?.status === "upcoming" ||
              concert?.status === "finished"
            }
            className="btn py-2 w-100 fs-7 fw-bolder bg-white rounded7 text-dark"
          >
            <CgShoppingBag className="ms-1" size={18} />
            خرید بلیط
          </button>
        </div>
      </div>
    </Link>
  );
}
